module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_WoodMatted.b5ade01f.jpg";